import React, { useState } from 'react';

const EcommerceWhatsAppFloating = ({
  phoneNumber,
  whatsappNumber,
  defaultMessage,
  customMessage,
  pillText = '¿Dudas? ¡Escribinos!',
  showPill = true,
  isVisible = true,
  onClose
}) => {
  const [internalVisible, setInternalVisible] = useState(() => {
    try {
      return sessionStorage.getItem('sigecom_wa_closed') !== 'true';
    } catch {
      return true;
    }
  });
  const [pillClosedByUser, setPillClosedByUser] = useState(false);

  const currentlyVisible = (isVisible !== undefined ? isVisible : true) && internalVisible;
  if (!currentlyVisible) return null;

  const actualPhone = phoneNumber || whatsappNumber || '5491142476622';
  const actualMessage = defaultMessage || customMessage || '¡Hola! Me comunico desde el sitio web para hacer una consulta.';
  const encodedMsg = encodeURIComponent(actualMessage);
  const isMobileOrTablet = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const cleanPhone = actualPhone.toString().replace(/\D/g, '');
  const whatsappUrl = isMobileOrTablet
    ? `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMsg}`
    : `https://web.whatsapp.com/send?phone=${cleanPhone}&text=${encodedMsg}`;

  const handleClose = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      sessionStorage.setItem('sigecom_wa_closed', 'true');
    } catch (err) {}
    setInternalVisible(false);
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('sigecom_whatsapp_closed'));
    }
    if (onClose) {
      onClose();
    }
  };

  const handlePillClick = (e) => {
    e.preventDefault();
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="ecom-whatsapp-float-wrapper" title="Consultar por WhatsApp">
      {/* Botón de cierre 'X' */}
      <button
        type="button"
        className="ecom-whatsapp-close"
        onClick={handleClose}
        title="Ocultar acceso a WhatsApp"
        aria-label="Cerrar acceso a WhatsApp"
      >
        <i className="bi bi-x-lg"></i>
      </button>

      {/* Cartelito flotante / Pill opcional */}
      {showPill && !pillClosedByUser && pillText && (
        <div 
          className="ecom-whatsapp-pill d-none d-sm-flex"
          onClick={handlePillClick}
        >
          <span className="badge bg-success-subtle text-success p-1 rounded-circle">
            <i className="bi bi-chat-dots-fill"></i>
          </span>
          <span>{pillText}</span>
          <i 
            className="bi bi-x text-muted ms-1 hover-danger" 
            title="Cerrar mensaje"
            onClick={(e) => {
              e.stopPropagation();
              setPillClosedByUser(true);
            }}
          />
        </div>
      )}

      {/* Botón Circular Principal */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="ecom-whatsapp-btn"
        aria-label="Contactar por WhatsApp"
      >
        <div className="ecom-whatsapp-pulse" />
        <i className="bi bi-whatsapp"></i>
      </a>
    </div>
  );
};

export default EcommerceWhatsAppFloating;
